export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  // Sider collapse button
  'component.sider.collapse': 'Collapse',

  // IconPicker
  'component.iconPicker.placeholder': 'Click to select icon',
  'component.iconPicker.modalTitle': 'Select Icon',
  'component.iconPicker.searchPlaceholder': 'Search icons',

  // MultiTab context menu
  'component.multiTab.refresh': 'Reload',
  'component.multiTab.close': 'Close Tab',
  'component.multiTab.closeLeft': 'Close Left Tabs',
  'component.multiTab.closeRight': 'Close Right Tabs',
  'component.multiTab.closeOthers': 'Close Other Tabs',
  'component.multiTab.closeAll': 'Close All Tabs',

  // 图片上传
  'component.iconUpload.upload': 'Upload',
  'component.iconUpload.uploadSucc': 'Upload successful',
  'component.iconUpload.uploadFail': 'Upload failed',

  // ProFormSelectWithAll
  'component.proFormSelectWithAll.selectAll': 'Select All',
  'component.proFormSelectWithAll.unselectAll': 'Unselect All'
};
